import { render, staticRenderFns } from "./payShop.vue?vue&type=template&id=aaa347fe&scoped=true&"
import script from "./payShop.vue?vue&type=script&lang=js&"
export * from "./payShop.vue?vue&type=script&lang=js&"
import style0 from "./payShop.vue?vue&type=style&index=0&id=aaa347fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa347fe",
  null
  
)

component.options.__file = "payShop.vue"
export default component.exports